module.exports = __webpack_public_path__ + "media/images/10_help-f6cc869973efa3fed7c0e187ad55ae99.jpg";